// extracted by mini-css-extract-plugin
export default {"header":"styles_header__OzRV9","logo":"styles_logo__NlsYu","logoText":"styles_logoText__l0G8r","location":"styles_location__W71BI"};